import type { Language } from './crs';

const ID = '[a-zA-Z0-9_-]{1,80}';
const publicDirectory = new RegExp(`^/(?:workspace/)?advisors(?:/${ID}(?:/request)?)?/?$`);
const applicant = new RegExp(`^/workspace/(?:consultations|applications)(?:/${ID}(?:/checkout)?)?/?$`);
const advisor = new RegExp(`^/consultants/(?:clients|consultations(?:/${ID}(?:/checkout)?)?|applications(?:/${ID}(?:/checkout)?)?|documents|shop|settings|qualification|workspace|policies|resources)/?$`);

export function isProfessionalPath(path: string): boolean {
  return publicDirectory.test(path) || applicant.test(path) || advisor.test(path);
}
export function professionalRoleForPath(path: string): 'applicant' | 'advisor' {
  if (advisor.test(path)) return 'advisor';
  return 'applicant';
}
export function isProfessionalWorkspacePath(path: string): boolean {
  return isProfessionalPath(path) && !path.startsWith('/advisors');
}
export function professionalPageTitle(path: string, language: Language): string {
  const title = path.endsWith('/checkout') ? ['付款', 'Checkout']
    : path.includes('/qualification') ? ['执业认证', 'Professional qualification']
    : path.includes('/shop') ? ['我的店铺', 'My shop']
    : path === '/consultants/workspace' ? ['工作概览', 'Work overview']
    : path.includes('/clients') ? ['客户', 'Clients']
    : path === '/consultants/policies' ? ['政策动态', 'Policy updates']
    : path === '/consultants/resources' ? ['资源库', 'Resources']
    : path.includes('/settings') ? ['设置', 'Settings']
    : path.includes('/documents') ? ['共享资料', 'Shared documents']
    : path.includes('/applications') ? ['我的申请', 'Applications']
    : path.includes('/consultations') ? ['我的咨询', 'Consultations']
    : path.endsWith('/request') ? ['申请咨询', 'Request a consultation']
    : ['顾问市场', 'Advisor marketplace'];
  return title[language === 'zh' ? 0 : 1];
}

/** Only bounded navigation selectors survive login; no personal data or tokens. */
export function professionalReturnSearch(params: URLSearchParams): string {
  const safe = new URLSearchParams();
  const tab = params.get('tab');
  if (params.getAll('tab').length === 1 && ['communication','messages','chat','overview','service','services','profile','availability','materials','documents','progress','agreement','imm5476','proposal','qualification'].includes(tab ?? '')) safe.set('tab', tab!);
  for (const key of ['service', 'agreement', 'application', 'request', 'order']) {
    const value = params.get(key);
    if (params.getAll(key).length === 1 && value && new RegExp(`^${ID}$`).test(value)) safe.set(key, value);
  }
  const installment = params.get('installment');
  if (params.getAll('installment').length === 1 && installment && /^(?:0|[1-9]\d?)$/.test(installment)) safe.set('installment', installment);
  return safe.size ? `?${safe}` : '';
}
